/**
 * Formik only shows a field's message once the field has been touched — the same
 * rule the legacy screen used, kept in one place.
 */
export const getFieldError = (formik, name) =>
  formik.touched[name] && formik.errors[name] ? formik.errors[name] : "";
